import React from 'react'
import PropTypes from 'prop-types'
import Provider from 'model/provider/provider'
import FacilityProfileV2 from 'model/facilities/facilityProfileV2'

import rightway_star from 'assets/rightway_star.svg'
import rightway_star_empty from 'assets/rightway_star_empty.svg'
import rightway_star_halved from 'assets/rightway_star_halved.svg'

import { RatingWrap, RatingStarRow, Rating } from './styled'

const getStar = (key, icon) => (
  <img key={key} src={icon} alt="Star" style={{ maxHeight: 20 }} />
)

const EntityRating = ({ entity, dataTest = 'entityRating' }) => {
  const rating = entity?.rating || 0
  const roundedRating = Math.floor(rating)
  const showHalved = rating !== roundedRating ? 1 : 0
  const stars = Array.from(Array(roundedRating)).map((_, i) => i)
  const missingScore = 5 - roundedRating
  const missingStars = Array.from(Array(missingScore - showHalved)).map(
    (_, i) => i
  )

  return (
    <RatingWrap data-test={dataTest}>
      <RatingStarRow data-test={`${dataTest}Stars`}>
        {stars.map(i => getStar(`${entity.id}_f${i}`, rightway_star))}
        {!!showHalved && getStar(`${entity.id}_halved`, rightway_star_halved)}
        {missingStars.map(i =>
          getStar(`${entity.id}_e${i}`, rightway_star_empty)
        )}
      </RatingStarRow>
      <Rating data-test={`${dataTest}Value`}>{rating}</Rating>
    </RatingWrap>
  )
}

EntityRating.propTypes = {
  entity: PropTypes.oneOfType([
    PropTypes.instanceOf(Provider),
    PropTypes.instanceOf(FacilityProfileV2)
  ]).isRequired
}

export default EntityRating
